import { Plant, InstagramLogo, FacebookLogo } from "@phosphor-icons/react";

export default function Footer() {
    return (
        <footer className="mt-8 md:mt-24 border-t border-border bg-white" data-testid="site-footer">
            <div className="hidden md:grid container-page py-14 grid-cols-1 lg:grid-cols-4 gap-10">
                <div>
                    <div className="flex items-center gap-2 mb-3">
                        <span className="w-9 h-9 rounded-lg bg-[#2E7D32] text-white grid place-items-center">
                            <Plant weight="fill" size={22} />
                        </span>
                        <div className="font-display font-extrabold text-lg">CampoDirecto</div>
                    </div>
                    <p className="text-sm text-muted-foreground max-w-xs leading-relaxed">
                        Del productor al comprador, sin intermediarios. Marketplace agrícola nacional preparado para comercio local, mayoreo y exportación.
                    </p>
                </div>
                <div>
                    <div className="eyebrow mb-3">Marketplace</div>
                    <ul className="space-y-2 text-sm">
                        <li><a href="/marketplace?category=ganaderia" className="hover:text-[#2E7D32]">Ganadería</a></li>
                        <li><a href="/marketplace?category=frutas" className="hover:text-[#2E7D32]">Frutas</a></li>
                        <li><a href="/marketplace?category=verduras" className="hover:text-[#2E7D32]">Verduras</a></li>
                        <li><a href="/marketplace?category=granos" className="hover:text-[#2E7D32]">Granos y cultivos</a></li>
                        <li><a href="/marketplace?category=forrajes" className="hover:text-[#2E7D32]">Forrajes</a></li>
                    </ul>
                </div>
                <div>
                    <div className="eyebrow mb-3">Para ti</div>
                    <ul className="space-y-2 text-sm">
                        <li><a href="/registro?redirect=%2Fpublicar&amp;action=publicar" className="hover:text-[#2E7D32]" data-testid="footer-sell-link">Vender en CampoDirecto</a></li>
                        <li><a href="/solicitudes" className="hover:text-[#2E7D32]">Solicitudes de compradores</a></li>
                        <li><a href="/atribucion-imagenes" className="hover:text-[#2E7D32]">Fuentes de imágenes</a></li>
                        <li><a href="/directorio/transportista" className="hover:text-[#2E7D32]">Logística y transporte</a></li>
                        <li><a href="/directorio/productor" className="hover:text-[#2E7D32]">Directorio de productores</a></li>
                    </ul>
                </div>
                <div>
                    <div className="eyebrow mb-3">Contacto</div>
                    <p className="text-sm text-muted-foreground">
                        México<br />
                        <a href="mailto:contacto@campodirecto.mx" className="hover:text-[#2E7D32] underline">contacto@campodirecto.mx</a>
                    </p>
                    <a href="/soporte" className="mt-3 inline-flex font-semibold text-sm text-[#2E7D32] hover:underline" data-testid="footer-support-link">Centro de ayuda y soporte</a>
                    <div className="flex gap-3 mt-3 text-muted-foreground">
                        <a
                            href="https://facebook.com/campodirecto"
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-[#1877f2]"
                            aria-label="Facebook CampoDirecto"
                            data-testid="footer-facebook"
                        >
                            <FacebookLogo size={22} />
                        </a>
                        <a
                            href="https://instagram.com/campodirecto"
                            target="_blank"
                            rel="noreferrer"
                            className="hover:text-[#E1306C]"
                            aria-label="Instagram CampoDirecto"
                            data-testid="footer-instagram"
                        >
                            <InstagramLogo size={22} />
                        </a>
                    </div>
                </div>
            </div>
            <div className="hidden md:block border-t border-border py-6">
                <div className="container-page flex flex-wrap gap-x-5 gap-y-2 justify-center text-xs text-muted-foreground">
                    <a href="/soporte" className="hover:text-[#2E7D32]">Soporte</a>
                    <a href="/legal/terminos" className="hover:text-[#2E7D32]">Términos</a>
                    <a href="/legal/privacidad" className="hover:text-[#2E7D32]">Privacidad</a>
                    <a href="/legal/cookies" className="hover:text-[#2E7D32]">Cookies</a>
                    <a href="/legal/terminos" className="hover:text-[#2E7D32]">Términos</a>
                    <a href="/legal/privacidad" className="hover:text-[#2E7D32]">Privacidad</a>
                    <a href="/legal/cancelacion" className="hover:text-[#2E7D32]">Cancelación</a>
                    <a href="/legal/publicaciones" className="hover:text-[#2E7D32]">Publicaciones</a>
                    <a href="/legal/productos-prohibidos" className="hover:text-[#2E7D32]">Productos prohibidos</a>
                    <a href="/legal/verificacion" className="hover:text-[#2E7D32]">Verificación</a>
                    <a href="/legal/disputas" className="hover:text-[#2E7D32]">Disputas</a>
                    <a href="/legal/propiedad-intelectual" className="hover:text-[#2E7D32]">Propiedad intelectual</a>
                    <a href="/legal/descargo" className="hover:text-[#2E7D32]">Descargo</a>
                    <a href="/legal/seguridad" className="hover:text-[#2E7D32]">Seguridad</a>
                </div>
            </div>
            <div className="md:hidden flex gap-5 justify-center py-3 text-xs">
                <a href="/soporte">Soporte</a>
                <a href="/legal/terminos">Términos</a>
                <a href="/legal/privacidad">Privacidad</a>
                <a href="/legal/seguridad">Seguridad</a>
            </div>
            <div className="border-t border-border py-5 text-center text-xs text-muted-foreground">
                © {new Date().getFullYear()} CampoDirecto. Gratis para compradores, productores y transportistas.
            </div>
        </footer>
    );
}
